<div class="com-year-picker-header">
    <div class="com-year-picker-previous" [ngClass]="{'dtp-btn-disabled':minYear>=firstYear}" (click)="previousPage();"><i class="fa fa-chevron-left"></i></div>
    <div class="com-year-picker-title">{{firstYear}}-{{lastYear}}</div>
    <div class="com-year-picker-next" [ngClass]="{'dtp-btn-disabled':lastYear>=maxYear}" (click)="nextPage();"><i class="fa fa-chevron-right"></i></div>
</div>
<ul class="com-year-picker-wrapper">
    <li class="com-picker-item" [ngClass]="{'com-m-y-disabled':year>maxYear||minYear>year}" (click)="yearClick(year)" *ngFor="let year of yearList"><span>{{year}}</span></li>
</ul>
